import React from 'react'

import './SymposiumSpeakerCard.css'

const SymposiumSpeakerCards = (props) => {
  return (
    <div className='SpeakerCard-container'>
      <div className='SpeakerCard-imgwrapper' style={{"backgroundImage":`linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.5)), url(${props.img})`}} >
        <div className='SpeakerCard-imgwrapper-date'>
          <p className='SpeakerCard-imgwrapper-date-p'>{props.date}</p>
        </div>
        <div className='SpeakerCard-imgwrapper-time'>
          <p className='SpeakerCard-imgwrapper-time-p'>{props.time}</p>
        </div>
        <div className='SpeakerCard-imgwrapper-title'>
          <p className='SpeakerCard-imgwrapper-title-p'>{props.title}</p>
        </div>
      </div>
      <div className='SpeakerCard-descwrapper'>
        <div className='SpeakerCard-namebox'>
          <p className='SpeakerCard-namebox-name'>{props.name}</p>
          <p className='SpeakerCard-namebox-affiliation'>{props.affiliation}</p>
        </div>
        <div className='SpeakerCard-cvbox'>
          <p className='SpeakerCard-cvbox-cv'>{props.cv_1}</p>
          <p className='SpeakerCard-cvbox-cv'>{props.cv_2}</p>
          <p className='SpeakerCard-cvbox-cv'>{props.cv_3}</p>
        </div>
      </div>
    </div>
  )
}

export default SymposiumSpeakerCards